/**
 * Calculates the cursor position in a formatted string based on the cursor position
 * in the raw input, by counting digits before the cursor.
 *
 * This is used to preserve cursor position when formatting numeric inputs like dates,
 * phone numbers, credit card expiry dates, etc.
 *
 * @param rawValue - The unformatted input value (may contain non-digit characters)
 * @param rawCursorPos - The cursor position in the raw input
 * @param formattedValue - The formatted output value
 * @returns The cursor position in the formatted string
 *
 * @example
 * // User types "9" to change "11/18/2025" to "11/19/2025"
 * calculateCursorPosition("11/192025", 5, "11/19/2025") // returns 5
 */
export const calculateCursorPosition = (
  rawValue: string,
  rawCursorPos: number,
  formattedValue: string
): number => {
  // Count digits before cursor in raw input
  let digitsBefore = 0;
  for (let i = 0; i < rawCursorPos; i++) {
    if (/\d/.test(rawValue[i])) digitsBefore++;
  }

  // Find cursor position in formatted string by counting the same number of digits
  let pos = 0;
  let counted = 0;
  for (pos = 0; pos < formattedValue.length; pos++) {
    if (counted === digitsBefore) break;
    if (/\d/.test(formattedValue[pos])) counted++;
  }

  return pos;
};
